//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Button from '@/components/Shared/Button.vue'

export default {
  name: 'NewOccupationWizardButtons',
  components: {
    Button,
  },
  props: {
    invalid: {
      type: Boolean,
      default: () => false,
    },
  },
  methods: {
    handleBack() {
      this.$emit('back')
    },
    handleContinue() {
      this.$emit('continue')
    },
  },
}
